import { removeEmptyKeys, isValueOrUndefined, getFirstMatchingValue } from '../../utils';
import styles from './index.module.css';
const possibleProps = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

/**
 * @typedef { 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 } p
 * @typedef { 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 } pb
 * @typedef { 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 } pl
 * @typedef { 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 } pr
 * @typedef { 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 } pt
 * @typedef { 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 } px
 * @typedef { 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 } py
 */

/**
 * @param p {p}
 * @param pb {pb}
 * @param pl {pl}
 * @param pr {pr}
 * @param pt {pt}
 * @param px {px}
 * @param py {py}
 *
 * @returns [className]
 */
const getPadding = (p, pb, pl, pr, pt, px, py) => {
  const paddingBottom = getFirstMatchingValue(possibleProps, [pb, py, p]);
  const paddingLeft = getFirstMatchingValue(possibleProps, [pl, px, p]);
  const paddingRight = getFirstMatchingValue(possibleProps, [pr, px, p]);
  const paddingTop = getFirstMatchingValue(possibleProps, [pt, py, p]);
  const classnames = removeEmptyKeys({
    // padding
    [styles[`paddingBottom${paddingBottom}`]]: isValueOrUndefined(paddingBottom),
    [styles[`paddingLeft${paddingLeft}`]]: isValueOrUndefined(paddingLeft),
    [styles[`paddingRight${paddingRight}`]]: isValueOrUndefined(paddingRight),
    [styles[`paddingTop${paddingTop}`]]: isValueOrUndefined(paddingTop)
  });

  /**
   * We return an array and not an object, for renaming reasons.
   */
  return [classnames];
};
export default getPadding;